import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const SDSUPhoto = () => {
  const data = useStaticQuery(graphql`
    query {
      sdImage: file(relativePath: { eq: "sdsu.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.sdImage.childImageSharp.fluid}
      alt="San Diego State University Image"
    />
  )
}

export default SDSUPhoto
